// Single source of truth: room field that holds each game's live state.
export const GAME_STATE_KEYS = {
  drawing: 'currentDrawer',
  ludo: 'ludoState',
  snakeladder: 'slState',
  uno: 'unoState',
  minigolf: 'miniGolfState',
  quiz: 'quizState',
  boggle: 'boggleState',
};
